import * as Helpers from "../js/helpers";
import Constants from "../js/constants";

export const asta_settings = (state, getters) => {
  // è solo uno shortcut per nn scrivere sempre asta_info.settings ma direttamente asta_settings
  return state.asta.info ? state.asta.info.settings : {}; // tanto settings nello stato è uguale a quello del getters
  // let asta_info = getters.asta_info
  // return (asta_info && asta_info.settings)? asta_info.settings : {}
};

export const svincolati =
  (state, getters) =>
  (
    selectedRuoloClassic,
    nameFilter,
    maxQuotazione = 0,
    includiScartati = false,
    escludiSquadre = [],
    selectedRuoliMantra = []
  ) => {
    var regex = new RegExp(nameFilter.toLowerCase());
    let settings = getters.asta_settings;
    let ids = includiScartati
      ? getters.svincolati_e_scartati_ids
      : getters.svincolati_ids;
    return _.orderBy(
      _.filter(ids, function (key) {
        // let calciatore = state.calciatori.all[key]
        let calciatore = getters.calciatori[key];
        return (
          (selectedRuoloClassic === 0 ||
            parseInt(calciatore.ID_Ruolo) === selectedRuoloClassic) &&
          (nameFilter.length < 1 ||
            regex.test(calciatore.calciatore.toLowerCase()) ||
            (calciatore.nomeClub &&
              regex.test(calciatore.nomeClub.toLowerCase()))) &&
          (maxQuotazione == 0 ||
            parseFloat(calciatore.quotazione) <= maxQuotazione) &&
          (escludiSquadre.length == 0 ||
            parseInt(calciatore.ID_Club) == 0 ||
            escludiSquadre.indexOf(
              selectedRuoloClassic + "_" + calciatore.ID_Club
            ) == -1) &&
          (selectedRuoliMantra.length == 0 ||
            _.intersection(calciatore.mantra_ids, selectedRuoliMantra).length >
              0)
        );
      }),
      [
        function (key) {
          // let calciatore = state.calciatori.all[key]
          let calciatore = getters.calciatori[key];
          if (
            settings.ch_list_order === Constants.CHOOSER_LIST_ORDER.QUOTAZIONE
          )
            return parseInt(calciatore.quotazione);
          if (settings.ch_list_order === Constants.CHOOSER_LIST_ORDER.NOME)
            return calciatore.calciatore;
        },
      ],
      [
        settings.ch_list_order === Constants.CHOOSER_LIST_ORDER.QUOTAZIONE
          ? "desc"
          : "asc",
      ]
    );
  };

export const assegnati_ids = (state) => {
  return _.keys(_.assign({}, ..._.map(state.squadre.all, "calciatori")));
};

// export const calciatori_ids = state => {
//   return _.keys(state.calciatori.all)
// }

export const calciatori_ids = (state, getters) => {
  return _.keys(getters.calciatori);
};

export const scartati_ids = (state) => {
  return _.keys(state.asta.scartati);
};

// Considero solo calciatori con ID_Club != 0
export const svincolati_ids = (state, getters) => {
  return _.difference(
    _.filter(getters.calciatori_ids, function (key) {
      // let calciatore = state.calciatori.all[key];
      let calciatore = getters.calciatori[key];
      return (
        parseInt(calciatore.ID_Club) !== 0 &&
        parseInt(calciatore.eliminato) !== 1
      );
    }),
    _.concat(getters.assegnati_ids, getters.scartati_ids)
  );
};

export const svincolati_e_scartati_ids = (state, getters) => {
  return _.difference(
    _.filter(getters.calciatori_ids, function (key) {
      // let calciatore = state.calciatori.all[key];
      let calciatore = getters.calciatori[key];
      return (
        parseInt(calciatore.ID_Club) !== 0 &&
        parseInt(calciatore.eliminato) !== 1
      );
    }),
    getters.assegnati_ids
  );
};

export const asta_squadre = (state, getters) => {
  const calciatori = getters.calciatori;
  const asta_info = getters.asta_info;

  for (let id in state.squadre.all) {
    let _squadra = state.squadre.all[id];

    _squadra.id = id;
    _squadra.active = _squadra.active !== undefined ? _squadra.active : 1;

    // numero acquisti per ruolo e lub
    _squadra.acquisti = _.countBy(
      _.keys(_squadra.calciatori),
      function (calciatore_id) {
        return calciatori[calciatore_id].ID_Ruolo;
      }
    );

    _squadra.acquistiPerClub = _.countBy(
      _.keys(_squadra.calciatori),
      function (b) {
        return calciatori[b].ID_Ruolo + "_" + calciatori[b].ID_Club;
      }
    );

    // ruolo/rosa completi
    _squadra.isRuoloCompleto = {};
    for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
      const nAcquistiRuolo = _squadra.acquisti[ruolo.ruolo_id] || 0;
      _squadra.isRuoloCompleto[ruolo.ruolo_id] = Helpers.isRuoloCompleto(
        ruolo.ruolo_id,
        nAcquistiRuolo,
        asta_info
      );
    }
    _squadra.isRosaCompleta = Object.values(_squadra.isRuoloCompleto).every(
      (value) => value === true
    );

    // crediti
    const crediti_extra = _squadra.crediti_extra || 0;
    _squadra.crediti_extra = crediti_extra;

    const crediti_spesi = _.sum(
      _.map(_squadra.calciatori, (c) => {
        return c.p;
      })
    );
    _squadra.crediti =
      state.asta.info.lega.crediti + crediti_extra - crediti_spesi;

    delete _squadra.plan;

    _squadra.max_offerta = Helpers.maxOfferta(
      state.asta.info.lega,
      _squadra.crediti,
      _.size(_squadra.calciatori)
    );

    const defaultSettings = {
      plan: {
        associazione: Constants.PLAN_ASSOCIAZIONE.AUTO,
        nRuoli: {
          nP: 3,
          nD: 8,
          nC: 8,
          nA: 6,
        },
      },
    };
    _squadra.settings = _.merge({}, defaultSettings, _squadra.settings);
  }
  return state.squadre.all;
};

export const asta_squadre_array = (state, getters) => {
  return _.orderBy(
    _.map(getters.asta_squadre, function (value, key) {
      return {
        id: key,
        name: value.name,
        order: value.order || 0,
        active: "active" in value ? value.active : 1,
      };
    }),
    [(squadra) => squadra.order]
  );
};

export const asta_squadre_active = (state, getters) => {
  return _.filter(getters.asta_squadre_array, function (o) {
    return o.active === 1;
  });
};

// Choosers ammessi (solo tra le squadre attive)
// export const asta_choosers = (state, getters) => {
//   let asta_info = getters.asta_info
//   let squadre_active = getters.asta_squadre_active
//   return _.filter(_.map(squadre_active, 'id'), (squadra_id) => {
//     let squadra = getters.asta_squadre[squadra_id]
//     return Helpers.canBeChooser(asta_info, squadra)
//   });
// }

export const asta_choosers = (state, getters) => {
  const asta_squadre_array = getters.asta_squadre_array;
  const asta_info = getters.asta_info;
  const asta_squadre = getters.asta_squadre;

  let output = [];

  for (const squadra_array of Object.values(asta_squadre_array)) {
    let squadra = asta_squadre[squadra_array.id];

    // add default props to squadra
    squadra.canBeChooser = true;
    squadra.msgIfNotChooser = "";

    // push
    let key = output.push(squadra) - 1;

    // se non c'è offerta contestuale, si può sempre essere un chooser ( patto di essere attivi)
    if (!asta_info.settings.offerta_auto && squadra.active) {
      continue;
    }

    // Non ha crediti sufficienti
    if (squadra.max_offerta < Constants.OFFERTA.MINIMA) {
      output[key].msgIfNotChooser = "No crediti";
      output[key].canBeChooser = false;
      continue;
    }
    // illimitate, almeno
    const regole_lega = asta_info.lega;
    if (
      (regole_lega.nRuoli.op == "illimitati" ||
        regole_lega.nRuoli.op == ">=") &&
      squadra.active
    ) {
      continue;
    } else {
      const ruolo_da_chiamare = asta_info.settings.ruolo_da_chiamare;
      if (ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE) {
        // controlla la rosa
        if (output[key].isRosaCompleta) {
          output[key].msgIfNotChooser = "Rosa completa";
          output[key].canBeChooser = false;
          continue;
        }
      } else {
        // controlla solo il ruolo
        if (output[key].isRuoloCompleto[ruolo_da_chiamare]) {
          output[key].msgIfNotChooser =
            Constants.RUOLI_NEW[ruolo_da_chiamare].plurale + " completati";
          output[key].canBeChooser = false;
          continue;
        }
      }
    }

    // se è stato escluso (deve stare al primo posto lo metto per ultimo perchè sennò nn si capisce che ha finito la rosa e il ruolo nel msg)
    if (!squadra.active) {
      output[key].msgIfNotChooser = "Squadra esclusa dall'asta";
      output[key].canBeChooser = false;
      continue;
    }
  }
  return output;
};

export const tot_squadre = (state) => {
  return _.size(state.squadre.all);
};

export const migliore_offerta = (state) => {
  let vincitore = _.maxBy(_.keys(state.asta.round.offerte), function (o) {
    return state.asta.round.offerte[o];
  });
  if (vincitore && state.asta.round.offerte[vincitore] > 0)
    return {
      vincitore: vincitore,
      offerta: state.asta.round.offerte[vincitore],
    };
  return {
    offerta: 0,
    vincitore: null,
  };
};
